import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { AbstractBaseComponent } from 'src/app/model/AbstractBaseComponent';
import { AFunzionalitaService } from '../a-funzionalita.service';

@Component({
  selector: 'app-download-studenti-placement',
  templateUrl: './download-studenti-placement.component.html',
  styleUrls: ['./download-studenti-placement.component.css'],
})
export class DownloadStudentiPlacementComponent
  extends AbstractBaseComponent
  implements AfterViewInit, OnInit, OnDestroy {
  // COMBO BOX
  submitted = false;
  constructor(
    public ngxSmartModalService: NgxSmartModalService,
    public router: Router,
    private spinner: NgxSpinnerService,
    private aFunzionalitaService: AFunzionalitaService
  ) {
    super();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  downloadStudentiPlacement() {
    this.spinner.show();
    this.aFunzionalitaService.downloadStudentiPlacement().subscribe(
      (result) => {
        const downloadURL = window.URL.createObjectURL(result);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download =
          'studenti_voto_placement_' + new Date().toISOString() + '.csv';
        link.click();
        this.spinner.hide();
      },
      (error) => {
        console.log('Errore prova:' + error);
        this.spinner.hide();
      }
    );
  }
}
